import { FC, useContext, useState } from "react";
import { useParams } from "react-router-dom";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../../context/notificationContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useAdminCostsApi } from "../../../http/costs/api";
import Button from "../../ui/Button";
import ModalDialog from "../../ui/ModalDialog";

interface ImportDkvTollsCostImportButtonProps {
  isDisabled?: boolean;
  onUpdate: () => void;
}

const ImportDkvTollsCostImportButton: FC<ImportDkvTollsCostImportButtonProps> = ({
  isDisabled,
  onUpdate,
}: ImportDkvTollsCostImportButtonProps) => {
  const i18n = useI18n();
  const costApi = useAdminCostsApi();
  const dispatch = useContext(NotificationDispatch);
  const { id } = useParams<{ id: string }>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const importCosts = async () => {
    setIsSubmitting(true);
    try {
      await costApi.importCosts(id!, "dkv_tolls");
      dispatch(showSuccessNotification(i18n.t));
      onUpdate();
      setShowDialog(false);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button
        buttonProps={{
          onClick: () => setShowDialog(true),
          disabled: !!isDisabled || isSubmitting,
        }}
      >
        {i18n.t.common.importInCosts}
      </Button>
      {!!showDialog && (
        <ModalDialog
          onClose={() => setShowDialog(false)}
          title={i18n.t.common.importInCosts}
          isSubmitting={isSubmitting}
          actions={[
            {
              title: i18n.t.common.cancel,
              type: "secondary",
              onClick: () => setShowDialog(false),
            },
            {
              title: i18n.t.common.yes,
              onClick: importCosts,
            },
          ]}
        >
          {i18n.t.costsImport.questions.importInCosts}
        </ModalDialog>
      )}
    </>
  );
};

export default ImportDkvTollsCostImportButton;
